<template>
  <div id="data-list-list-view" class="datatable-container">
    <!--Filter-->
    <lhdn-submissions-filter @change="onChangeFilter" />

    <vx-card class="mt-5">
      <h4 class="card-title">Results</h4>
      <!--      ({{ totalItem }})</h4>-->
      <vs-table
        v-show="this.loaded"
        stripe
        ref="table"
        :data="this.submissions"
        multiple
        v-model="selected"
      >
        <template slot="thead">
          <vs-th sort-key="uuid">Internal ID</vs-th>
          <vs-th sort-key="submissionId">Submission ID</vs-th>
          <vs-th sort-key="submissionStatus">Status</vs-th>
          <vs-th sort-key="createdAt">Created At</vs-th>
          <vs-th sort-key="invoiceDate">Submitted At</vs-th>
          <vs-th sort-key="updatedAt">Updated At</vs-th>
          <vs-th>Action</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                <p class="product-name">
                  <a @click="handleUpdate(tr)">{{ tr.uuid }}</a>
                </p>
              </vs-td>
              <vs-td>
                <p class="product-name">
                  {{ tr.submissionId }}
                </p>
              </vs-td>
              <vs-td>
                <vs-chip
                  :color="getStatusColor(tr.submissionStatus)"
                  class="product-order-status"
                >
                  {{ tr.submissionStatus }}
                </vs-chip>
              </vs-td>
              <vs-td>
                <p class="product-name">
                  {{ tr.createdAt | moment('DD MMM YYYY, hh:mm A') }}
                </p>
              </vs-td>
              <vs-td>
                <p class="product-name">
                  {{
                    tr.invoiceDate | moment('DD MMM YYYY')
                  }}
                </p>
              </vs-td>
              <vs-td>
                <p class="product-name">
                  {{ tr.updatedAt | moment('DD MMM YYYY') }}
                </p>
              </vs-td>
              <vs-td class="whitespace-no-wrap">
                <feather-icon
                  icon="EyeIcon"
                  svgClasses="w-5 h-5 hover:text-primary stroke-current"
                  class="ml-2"
                  @click.stop="handleUpdate(tr)"
                />
                <feather-icon
                  icon="SendIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-2"
                  @click.stop="handleSubmit(tr)"
                />
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
      <template v-if="totalPage > 0">
        <vs-pagination
          :total.sync="totalPage"
          v-model="currentPage"
        ></vs-pagination>
      </template>
    </vx-card>
  </div>
</template>

<script>
import LhdnSubmissionStatus from '@/mixins/lhdn-submission-status'
import LhdnSubmissionsFilter from "@/views/apps/lhdn-submissions/LhdnSubmissionsFilter";

export default {
  components: {
    LhdnSubmissionsFilter,
  },
  mixins: [LhdnSubmissionStatus],
  data() {
    return {
      selected: [],
      submissions: null,
      itemsPerPage: 25,
      loaded: false,
      currentPage: 1,
      pageTotal: 0,
      totalItem: 0,
      totalPage: 0,
      sortBy: {
        "updatedAt":"DESC"
      },
      filter: {
        submissionId: null,
        status: null,
      },
      activeTenant: this.$store.state.AppActiveUser.activeTenant,
    }
  },
  watch: {
    currentPage(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.getRecords()
      }
    },
  },
  computed: {
    queriedItems() {
      if (this.totalItem) {
        return this.totalItem
      }
      return 0
    },
    filterParams() {
      const entries = Object.entries(this.filter)
      if (!entries.length) return null

      return entries
        .filter(([, value]) => value)
        .map(([key, value]) => ({
          [key]: key === 'status' ? value : { $contL: value },
        }))
    },
    sortParams() {
      const entries = Object.entries(this.sortBy)
      console.log(`sort params ${JSON.stringify(entries)}`)
      return entries.length
        ? entries.map(([field, direction]) => `${field},${direction}`).join('')
        : ''
    },
  },
  methods: {
    async getRecords() {
      try {
        const response = await this.$store
          .dispatch('lhdnSubmissions/fetchRecords', {
            page: this.currentPage,
            limit: this.itemsPerPage,
            s: this.search,
            sort: this.sortParams
          })
        if(response)
          this.submissions = response.data
        console.log(`get records ${JSON.stringify(response.data)}`)
        this.loaded = true

        console.log(`get records ${JSON.stringify(response.data)}`)
        this.currentPage = parseInt(response.headers['x-pagination-page'])
        this.pageTotal = parseInt(response.headers['x-pagination-count'])
        this.totalItem = parseInt(response.headers['x-pagination-total'])
        this.totalPage = parseInt(response.headers['x-pagination-page-count'])
      } catch (e) {
        console.error(e.toString())
      }
    },
    async onChangeFilter(search) {
      this.currentPage = 1
      this.search = search
      await this.getRecords()
    },
    handleUpdate(item) {
      this.$router.push('/lhdn-submissions/' + item.uuid).catch(() => {})
    },
  },
}
</script>
